"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FeatureBanner;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _image = require("@site/pattern-library-core/image");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _icon = require("@site/pattern-library-utils/icon");
var _density = require("@site/pattern-library-utils/density");
var _productContent = _interopRequireDefault(require("../common/product-content"));
const BannersContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "BannersContainer",
  class: "pc-b4i4ay5"
});
const IconContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "IconContainer",
  class: "pc-iy971ul"
});
const Image = /*#__PURE__*/(0, _react2.styled)(_image.LazyImage)({
  name: "Image",
  class: "pc-i6kp1jf"
});

/**
 * FeatureBanner Component.
 *
 * @param {Object} props React props
 * @param {string} props.id FeatureBanners content id
*  @param {string} props.title The title of the feature banners item
 * @param {Array} props.banners The description of the checkout item
 * @returns {React.ReactElement} FeatureBanners Component
 * @public
 */
function FeatureBanner({
  id,
  title,
  description,
  icon,
  image,
  flyout,
  partial,
  list
}) {
  return /*#__PURE__*/_react.default.createElement(BannersContainer, {
    "data-cy": "feature-banner",
    "data-partial": `precheck ${partial || ''}`,
    key: id
  }, image && /*#__PURE__*/_react.default.createElement(Image, (0, _extends2.default)({
    className: "banner-image",
    "data-cy": "banner-image"
  }, image)), icon && !image && /*#__PURE__*/_react.default.createElement(IconContainer, null, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    className: "banner-icon",
    "data-cy": "banner-icon",
    name: (0, _icon.normalizeIconName)(icon)
  })), /*#__PURE__*/_react.default.createElement(_productContent.default, {
    title: title,
    description: description,
    flyout: flyout,
    list: list,
    titleSize: 0,
    dataCy: "banner"
  }));
}
FeatureBanner.propTypes = {
  id: _propTypes.default.string,
  title: _propTypes.default.string,
  description: _propTypes.default.string,
  icon: _propTypes.default.string,
  image: _propTypes.default.shape(_image.imgPropShape),
  flyout: _propTypes.default.object,
  partial: _propTypes.default.string,
  list: _propTypes.default.arrayOf(_propTypes.default.shape({
    content: _propTypes.default.string.isRequired
  }))
};